import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "notification-bell",
  ref: "bellRef"
}
const _hoisted_2 = {
  key: 0,
  class: "badge"
}
const _hoisted_3 = {
  key: 0,
  class: "notifications-dropdown"
}
const _hoisted_4 = { class: "dropdown-header" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "header-actions" }
const _hoisted_7 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_8 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_9 = {
  key: 2,
  class: "notifications-list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "notif-content" }
const _hoisted_12 = { class: "notif-header" }
const _hoisted_13 = { class: "notif-title" }
const _hoisted_14 = { class: "notif-time" }
const _hoisted_15 = { class: "notif-message" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "dropdown-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["bell-btn", { 'has-notifications': _ctx.unreadCount > 0 }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: "bell",
        class: "bell-icon"
      }),
      (_ctx.unreadCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.unreadCount > 99 ? '99+' : _ctx.unreadCount), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_Transition, { name: "slide-down" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_font_awesome_icon, { icon: "bell" }),
                  _cache[3] || (_cache[3] = _createTextVNode(" Notifications ", -1))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.unreadCount > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "mark-all-read",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.markAllAsRead && _ctx.markAllAsRead(...args)))
                      }, " Tout marquer comme lu "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "close-dropdown",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args))),
                    title: "Fermer"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: "times" })
                  ])
                ])
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("div", { class: "spinner" }, null, -1)
                  ]))]))
                : (_ctx.notifications.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_font_awesome_icon, { icon: "bell-slash" }),
                      _cache[5] || (_cache[5] = _createElementVNode("p", null, "Aucune notification", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notif) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: notif.id,
                          class: _normalizeClass(["notification-item", { unread: !notif.is_read }]),
                          onClick: ($event: any) => (_ctx.handleNotificationClick(notif))
                        }, [
                          _createElementVNode("div", {
                            class: "notif-icon",
                            style: _normalizeStyle({ background: notif.color })
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: notif.icon
                            }, null, 8, ["icon"])
                          ], 4),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("span", _hoisted_13, _toDisplayString(notif.title), 1),
                              _createElementVNode("span", _hoisted_14, _toDisplayString(notif.time_ago), 1)
                            ]),
                            _createElementVNode("p", _hoisted_15, _toDisplayString(notif.message), 1)
                          ]),
                          (!notif.is_read)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "notif-mark-read",
                                onClick: _withModifiers(($event: any) => (_ctx.markAsRead(notif)), ["stop"]),
                                title: "Marquer comme lu"
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: "check" })
                              ], 8, _hoisted_16))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_10))
                      }), 128))
                    ])),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_router_link, {
                  to: "/notifications",
                  onClick: _ctx.closeDropdown
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" Voir toutes les notifications ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}